import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/** 与后端 PreBillRevisionUploadPolicy.US_PACIFIC 一致 */
export const PRE_BILL_REVISION_PACIFIC_TZ = 'America/Los_Angeles';

/** 提示文案暂不使用多语言，与后端 PreBillRevisionUploadPolicy 保持一致 */
export const PRE_BILL_REVISION_WEEKLY_SUBMISSION_HINT =
    '每周的修订操作必须在周一（美西）12:00点前完成提交，否则将会影响数据同步和半价计费。';

export const PRE_BILL_REVISION_WEEKLY_WINDOW_BLOCKED_MESSAGE =
    '当前处于每周维护窗口（美西周一 12:00 至周一 21:00），暂不允许提交出账前订正';

export const preBillRevisionInProgressTaskBlockedMessage = (taskId: number | string): string =>
    `当前存在处理中的出账前订正任务（任务编号：${taskId}），请待其完成后再上传`;

/** 美西周一 12:00 起至周一 21:00 前禁止上传（与后端逻辑一致） */
export const isPreBillRevisionWeeklyWindowBlocked = (now: dayjs.Dayjs = dayjs()): boolean => {
    const pacific = now.tz(PRE_BILL_REVISION_PACIFIC_TZ);
    const day = pacific.day(); // 0=Sunday, 1=Monday
    const minutes = pacific.hour() * 60 + pacific.minute();
    return day === 1 && minutes >= 12 * 60 && minutes < 21 * 60;
};
